<template>
  <!--<div
    class="abt_box"
    :style="
      'background-image:url(' +
      require('../../../assets/images/about_bg_1.png') +
      ');'
    "
  >-->
  <div class="abt_box">
    <div class="abt_cent">
      <!-- <div class="abt_top"></div> -->
      <!-- <div class="abt_title">
        <span class="sp_1">{{
          lange == "ch" ? titleObj.a1.ch : titleObj.a1.en
        }}</span>
        <span class="sp_2">ABOUT EASYTIMES IP</span>
        <span class="sp_3">{{
          lange == "ch" ? titleObj.a2.ch : titleObj.a2.en
        }}</span>
      </div> -->
      <!-- <img class="imgss" src="@/assets/images/about_ico_1.png" /> -->

      <!-- 内容 start -->
      <div class="abt_nr">
        <div class="abt_n_title1">
          {{ lange == "ch" ? contact.cnTitle : contact.enTitle }}
        </div>
        <!-- <div class="abt_n_title2">
          {{ lange == "ch" ? contact.title2 : contact.title2 }}
        </div> -->
        <!-- <div class="abt_n_title3">
          {{ lange == "ch" ? contact.cnDetail : contact.enDetail }}
        </div> -->
        <div
          class="abt_n_cat"
          v-html="lange == 'ch' ? contact.cnDetail : contact.enDetail"
        ></div>
      </div>
    </div>
    <div class="gao"></div>
  </div>
</template>

<script>
import { newsDetail } from "@/api/index";
export default {
  name: "DetailsCat",
  components: {},
  data() {
    return {
      lange: this.$cookies.getCookie("language"),
      titleObj: {
        a1: {
          ch: "关于",
          en: "ABOUT",
        },
        a2: {
          ch: "我们",
          en: "US",
        },
      },
      contact: {},
    };
  },
  created() {
    this.$nextTick(() => {
      this.funcDetail(this.$route.query.id);
    });
  },
  methods: {
    funcDetail(id) {
      //最新资讯详情
      var params = {
        id: id,
      };
      newsDetail(params)
        .then((response) => {
          this.contact = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  props: ["content"],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.abt_box {
  width: 100%;
  min-height: 600px;
  display: block;
  background-color: #f6f8fd;
  position: relative;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100% auto;
}
.abt_cent {
  width: 90%;
  min-height: 300px;
  display: block;
  margin: 0 0 20% 10%;
  background-color: #fff;
  position: relative;
}
.abt_top {
  width: 100%;
  height: 30px;
  display: block;
  position: absolute;
  background-color: #fff;
  opacity: 0.7;
  top: -30px;
  left: 0;
}
.abt_title {
  width: 240px;
  height: 240px;
  display: block;
  position: absolute;
  top: -130px;
  right: 15%;
  background-color: #bda67d;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.2);
}

.abt_title > span {
  width: 100%;
  display: block;
  text-align: center;
}
.sp_1,
.sp_3 {
  font-size: 36px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 4px;
}
.sp_1 {
  margin-top: 25%;
}
.sp_2 {
  font-size: 12px;
  color: #fff;
}
.imgss {
  width: 20px;
  height: 76px;
  display: block;
  position: absolute;
  left: -16px;
  top: 30%;
}
.abt_nr {
  width: 78%;
  display: block;
  padding: 60px 0 160px 5%;
}
.abt_n_title1 {
  width: 100%;
  display: block;
  font-size: 20px;
  color: #213546;
  font-weight: bold;
  padding: 0 0 20px 0;
}
.abt_n_title2 {
  display: inline-block;
  font-size: 14px;
  color: #bda67d;
  border: 1px solid #bda67d;
  padding: 5px 20px;
  margin: 10px 0 50px 0;
}
.abt_n_title3 {
  width: 100%;
  display: block;
  font-size: 16px;
  color: #bda67d;
  font-weight: bold;
}
.abt_n_cat {
  width: 100%;
  display: block;
  font-size: 16px;
  color: #bda67d;
  line-height: 30px;
}
.gao {
  width: 100%;
  height: 1px;
  display: block;
}
@media only screen and (max-width: 1440px) {
  .abt_nr {
    width: 75%;
  }
}

@media only screen and (max-width: 1300px) {
  .abt_title {
    width: 200px;
    height: 200px;
    display: block;
    position: absolute;
    top: -160px;
    right: 5%;
    background-color: #bda67d;
    box-shadow: 0 0 18px rgba(0, 0, 0, 0.2);
  }
}
@media only screen and (max-width: 600px) {
  .abt_nr {
    width: 85%;
  }
}
@media only screen and (max-width: 425px) {
  .abt_title {
    width: 150px;
    height: 150px;
    top: -110px;
  }
  .sp_1 {
    margin-top: 12%;
  }
  .abt_n_title1 {
    font-size: 16px;
  }
  .abt_n_title2 {
    font-size: 12px;
    margin: 10px 0 20px 0;
  }
  .abt_n_title3 {
    font-size: 14px;
  }
  .abt_n_cat {
    font-size: 12px;
    line-height: 24px;
    padding: 20px 0 0 0;
  }
  .abt_nr {
    padding: 30px 5%;
    width: 85%;
    padding: 60px 8%;
  }
  .abt_cent{
    width: 100%;
    margin: 0 0 20% 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Details/component/DetailsCat.vue